<div class="srp-bootstrap no-focus-outline">
    <dt-loadingcomponent></dt-loadingcomponent>
    <router-outlet></router-outlet>
</div>
